import { render, staticRenderFns } from "./SidebarContactStatsBlock.vue?vue&type=template&id=ccc6da2c&scoped=true"
import script from "./SidebarContactStatsBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarContactStatsBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarContactStatsBlock.vue?vue&type=style&index=0&id=ccc6da2c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc6da2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccc6da2c')) {
      api.createRecord('ccc6da2c', component.options)
    } else {
      api.reload('ccc6da2c', component.options)
    }
    module.hot.accept("./SidebarContactStatsBlock.vue?vue&type=template&id=ccc6da2c&scoped=true", function () {
      api.rerender('ccc6da2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarContactStatsBlock.vue"
export default component.exports